<template>
  <div class="up-shop-btn">
    <el-switch
      v-model="newData.value"
      @change="handleChange"
    ></el-switch>
    <span class="word">{{newData.name}}</span>
  </div>
</template>

<script>
export default {
  name: 'upShopBtn',
  props: {
    data: Object
  },
  watch: {
    data (vl) {
      this.newData = vl
    }
  },
  data () {
    return {
      newData: this.data
    }
  },
  methods: {
    handleChange () {
      this.$emit('change', this.newData.value)
    }
  }
}
</script>

<style lang="scss" scoped>
  .up-shop-btn{
    display: flex;
    flex-direction: row;
    align-items: center;

    .word{
      margin-left: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/IMTable/components/tdBox/components/upShopBtn/index.vue